import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru D - sedan widok lewy
 */
export const AreaD_Sedan_Left: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="70"
      height="170"
      viewBox="0 0 70 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_d_sedan_left"
          x="0"
          y="0"
          width="70"
          height="170"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_d_sedan_left)">
        <path
          d="M23.8135 74.1443C22.1688 78.5719 20.0296 82.777 17.393 86.6822C21.6058 102.482 25.4803 116.041 27.6526 122.087C28.6611 124.895 29.4318 126.22 30.6137 127.33C31.3699 128.04 32.39 128.751 33.9434 129.589C34.0387 129.067 34.1317 128.55 34.2238 128.037L34.2246 128.033C34.2651 127.808 34.3054 127.583 34.3457 127.36C34.3844 127.145 34.4231 126.931 34.4619 126.718C34.899 124.315 35.3636 121.912 36.0212 119.823C36.7255 117.585 38.6215 114.468 42.1543 113.898C46.39 113.214 49.0673 116.265 50.8077 119.593C50.8463 119.666 50.8825 119.741 50.9163 119.817C52.9794 124.452 54.0109 128.274 54.0109 133.014C54.0109 136.207 54.3211 149.125 54.6994 161.415C55.1897 160.336 55.6903 159.178 56.2005 157.942C59.1364 150.829 62.2471 141.504 65.4769 130.88C65.2744 127.657 62.3332 42.5141 61.8714 13.7372C60.8601 14.6741 59.7233 15.7168 58.4722 16.6245C55.6569 18.6671 52.3232 19.9831 47.6148 19.619C39.3111 18.9766 31.0019 14.9544 18.2676 7.956C15.1234 6.228 11.6789 4.29906 7.85839 2.15957C6.61321 1.46227 5.32768 0.742368 4 0C6.86121 2.14078 9.47305 4.50694 11.8331 7.0686C22.6017 18.7572 27.8583 34.2218 27.9283 50.122C27.9649 58.5156 26.5977 66.649 23.8135 74.1443Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
